import React from 'react';

interface LessonContentProps {
  microId: string;
}

export const LessonContent: React.FC<LessonContentProps> = ({ microId }) => {
  // Narrative bridges now display in MicroLessonLayout header
  // This component can return null for most lessons since chat is the main content

  switch (microId) {

    // All Ch2 and Ch3 lessons now use narrative bridge in header
    // No additional content needed - chat is primary interface
    case 'quality-control':
    case 'ai-briefing':
    case 'content-intelligence':
    case 'strategic-direction':
    case 'communication-systems':
    case 'analyze-options':
    case 'build-plans':
    case 'monitor-finances':
    case 'optimize-workflows':
    case 'automated-oversight':
      return null; // Narrative is in header, chat interface is below

    // AI Foundations lessons (14 lessons) - All use narrative bridge in header
    case 'ai-foundations-be-specific':
    case 'ai-foundations-provide-context':
    case 'ai-foundations-set-format':
    case 'ai-foundations-include-examples':
    case 'ai-foundations-raise-framework':
    case 'ai-foundations-understand-models':
    case 'ai-foundations-text-image-tools':
    case 'ai-foundations-ai-limitations':
    case 'ai-foundations-tool-strategy':
    case 'ai-foundations-ethical-considerations':
    case 'ai-foundations-data-privacy':
    case 'ai-foundations-bias-fairness':
    case 'ai-foundations-ethical-guidelines':
    case 'ai-foundations-setup-toolkit':
      return null; // Narrative is in header, chat interface is below

    // Default
    default:
      return null;
  }
};